import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Domingos perdidos buscando esquemas de células o redes tróficas que se vean bien al imprimir.', 'Clases desconectadas porque no tenés una secuencia clara entre lo que ven en 1° y lo que necesitan en 4°.', 'Laboratorios que son un caos porque no tenés guías de registro ni protocolos "low cost" listos.', 'El estrés del cierre: Horas redactando exámenes y "frases de boletín" para 200 alumnos.'];
export function PainPointsSection() {
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-205">
          Si sos docente de Biología en secundaria,{' '}
          <br className="hidden md:block" data-id="element-206" />
          <span className="text-brand-orange" data-id="element-207">
            esto te va a sonar familiar:
          </span>
        </h2>

        <div className="space-y-4 md:space-y-6 mb-8 md:mb-12 bg-red-50 p-5 md:p-8 rounded-2xl border border-red-100" data-id="element-208">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-209">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-210" />
              <p className="text-xl font-medium text-gray-800" data-id="element-211">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-212">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-5 md:mb-8" data-id="element-213">
            ¿Cuántos domingos más vas a sacrificar?
          </h3>
          <div className="max-w-xl mx-auto" data-id="element-214">
            <CTAButton text="→ QUIERO DEJAR DE IMPROVISAR" href="#compra" data-id="element-215" />
          </div>
        </div>
      </div>
    </section>;
}